
// Common utility functions used across the article services

/**
 * Extracts plain text content from Editor.js blocks
 */
export const extractPlainTextFromBlocks = (blocks: any[]) => {
  if (!blocks || !blocks.length) return '';
  
  return blocks.map(block => {
    switch (block.type) {
      case 'paragraph':
        return block.data.text?.replace(/<[^>]*>/g, '') || '';
      case 'header':
        return block.data.text || '';
      case 'list':
        return (block.data.items || []).join('\n');
      case 'quote':
        return `${block.data.text || ''}\n- ${block.data.caption || ''}`;
      case 'warning':
        return `${block.data.title || ''}\n${block.data.message || ''}`;
      case 'image':
        return block.data.caption || '';
      default:
        return '';
    }
  }).join('\n\n');
};

/**
 * Transform article data from database format to client format
 */
export const transformArticleForClient = (article: any) => {
  if (!article) return null;
  
  // Get the author data if available
  const author = article.author ? {
    id: article.author.id,
    name: article.author.display_name,
    avatar: article.author.avatar_url,
    bio: article.author.bio,
    isFollowed: false // Default value, would be updated later if needed
  } : null;
  
  return {
    ...article,
    content: article.content && typeof article.content === 'object' ? 
      extractPlainTextFromBlocks(article.content.blocks || []) : 
      article.content, // For legacy components that expect string content
    cover_image: article.featured_image_url,
    read_time: article.reading_time,
    access_type: article.payment_type,
    price: article.micropayment_price,
    views: article.view_count, // Map view_count to views for backward compatibility
    editor_data: article.content, // Store the structured content separately
    author, // Add the properly formatted author data
    author_id: article.author_id,
    author_name: author?.name || 'Unknown Author',
    author_avatar: author?.avatar
  };
};
